import { render, staticRenderFns } from "./MenuFormulariosTrabalhos.vue?vue&type=template&id=0188e2bb&scoped=true"
import script from "./MenuFormulariosTrabalhos.vue?vue&type=script&lang=js"
export * from "./MenuFormulariosTrabalhos.vue?vue&type=script&lang=js"
import style0 from "./MenuFormulariosTrabalhos.vue?vue&type=style&index=0&id=0188e2bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0188e2bb",
  null
  
)

export default component.exports